import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

interface SortableItemProps {
  index: number
  row: any
  enableSorting?: boolean
  children?: React.ReactNode
  rowClass?: string

}

const SortableItem: React.FunctionComponent<SortableItemProps> = (props: SortableItemProps) => {

  const { attributes, listeners, transform, transition, setNodeRef, setActivatorNodeRef } =
    useSortable({ id: props.row.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const rowAttr: object = { index: props.index }

  let checkboxCell = null
  let otherChildren = props.children

  
  if (Array.isArray(props.children)) {
    const [firstChild, ...rest] = props.children

    if (
      firstChild?.props?.tableColumn?.type &&
      String(firstChild.props.tableColumn.type) === 'Symbol(select)'
    ) {
      checkboxCell = firstChild
      otherChildren = rest
    }
  }

  return (
    <tr style={style} ref={setNodeRef} {...rowAttr} className={props.rowClass}>
      {checkboxCell}
      <OverlayTrigger
        placement='right'
        delay={{ show: 1250, hide: 100 }}
        overlay={
          <Tooltip>{'Drag and drop this line to change the order of an item in the list'}</Tooltip>
        }
      >
        <td
          {...(props.enableSorting !== false ? listeners : {})}
          {...(props.enableSorting !== false ? attributes : {})}
          ref={setActivatorNodeRef}
          className='dx-g-bs4-table-cell text-nowrap'
        >
          <span>{'::::'}</span>
        </td>
      </OverlayTrigger>
      {otherChildren}
    </tr>
  )
}

export default SortableItem
